<template>
  <div
    class="px-1 border-2 flex border-primary-400 bg-white hover:bg-primary-50 dark:bg-dark-400 dark:border-dark-200"
    style="transition: background-color 1s"
    :style="`width: ${width}; height: ${height}; border-radius: ${radius}; margin-top: ${margin_top}; margin-bottom: ${margin_bottom}`"
  >
    <span class="material-icons text-2xl my-auto mx-1 text-gray-400 dark:text-dark-text"> search </span>
    <input
      v-model="value"
      class="w-full focus:outline-none text-gray-800 dark:text-dark-text bg-transparent"
      name="problemId"
      :placeholder="placeholder"
      type="text"
      @keydown.enter="enterForm(value)"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  props: {
    width: {
      type: String,
      default: '240px'
    },
    height: {
      type: String,
      default: '40px'
    },
    margin_top: {
      type: String,
      default: '14px'
    },
    margin_bottom: {
      type: String,
      default: '14px'
    },
    placeholder: {
      type: String,
      default: ''
    },
    radius: {
      type: String,
      default: '1rem'
    },
    type: {
      type: String,
      default: 'text'
    }
  },
  setup(props, ctx) {
    const value = ref('')

    const enterForm = (value: string) => {
      ctx.emit('enterForm', value)
    }

    return {
      enterForm,
      value
    }
  }
})
</script>

<style>
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  transition: background-color 5000000s ease-in-out 0s;
}
</style>
